import { CalendarIcon } from '../../../../common/ui/icons';
import SectionTodos from '../section/section-todos';
import { INDEX_PROJECT_ID } from '../../domain/planner-provider';
import ProjectView from '../projects/project-view';
import ActiveTodos from '../active-todos/active-todos';
import TodayNote from './today-note';
import { useEffect, useState } from 'react';
import HideProjectAndSectionTitlesCB from '../projects/actions/project-hide-titles-cb';
import Actions from '../../../../common/ui/actions';
import CloseAllProjectsBtn from './actions/close-all-projects-btn';
import { usePlannerStore } from '../../data/planner-store';
import ProjectShowDescriptionsCB from '../projects/actions/project-show-desc-cb';
import TagFilters from './tag-filters/tag-filters';
import CommonBlocksYearMonthView from '../../../../common/ui/blocks-year/common-month-view';
import { ITodo } from '../../planner-interfaces';
import CommonBlocksYearTodoEditForm from '../../../../common/ui/blocks-year/common-blocks-todo-edit';
import { IBlocksCalendarMonth, IBlocksCalendarYear } from '../../../blocks-year/blocks-year-interfaces';
import { TAG_FILTER_THINK_COFFEE } from '../../domain/tags-provider';
import TodayAIActions from './ai/today-ai-actions';
import TodosCount from '../todos-count';
import { getCombinedProjectCounts } from '../../domain/count-provider';
// import TodoDiagramEntryPoint from '../../../todo-diagram-editor/diagram-entry-point';
// import MarkdownEditor from '../../../markdown-editor/index';

const TodayView = () => {

    const combinedProject = usePlannerStore(state => state.combinedProject);

    const [yBlocksEditPopupTodo, setYBlocksEditPopupTodo] = useState<ITodo|null>(null);
    const [yBlocksMonthData, setYBlocksMonthData] = useState<IBlocksCalendarMonth|null>(null);

    const count = getCombinedProjectCounts(combinedProject);

    useEffect(() => {
        document.title = `Today (${ count.rootTodosCount }) | Productivity`;
    }, [count]);

    useEffect(() => {
        if(!combinedProject?.yBlocks?.months?.length) return;

        const monthIndex = (new Date().getMonth());

        const month = combinedProject.yBlocks.months[monthIndex];

        setYBlocksMonthData(month);
    }, [combinedProject?.yBlocks?.months]);

    const onYearBlocksUpdate = (_data: IBlocksCalendarYear|null) => {
        if(!_data) return;

        const monthIndex = (new Date().getMonth());

        const month = _data.months[monthIndex];

        setYBlocksMonthData(month);
    };

    const onBlocksYearEditPopupClose = () => {
        setYBlocksEditPopupTodo(null);
    };

    const getYBlocks = () => {
        if(!yBlocksMonthData) return <></>;

        return (
            <div className="mb-8">
                <CommonBlocksYearMonthView
                    month={ yBlocksMonthData }
                    setOpenedEditTodo={ setYBlocksEditPopupTodo }
                />

                {
                    yBlocksEditPopupTodo &&
                    <CommonBlocksYearTodoEditForm
                        onClose={ onBlocksYearEditPopupClose }
                        currentYear={ (new Date()).getFullYear() }
                        tags={ combinedProject?.yBlocks?.tags || [] }
                        setData={ onYearBlocksUpdate }
                        tag_id={ TAG_FILTER_THINK_COFFEE }
                        openedEditTodo={ yBlocksEditPopupTodo }
                    />
                }
            </div>
        )
    };

    return (
        <>
            <div className="xl:w-[800px] max-w-full mx-auto">
                <div className="mb-4 w-full flex flex-col">

                <h1 className="text-xl xl:text-3xl border-b border-teal-400 pb-2 flex items-center">
                        <CalendarIcon classes="mr-4" size={ 35 } color={ '#2E766E' } />
                        Today

                        <TodosCount count={ count } />

                        <Actions mr="mr-0" gridSize={ 1 }>
                            <CloseAllProjectsBtn />
                        </Actions>
                    </h1>

                    {
                        /**
                         * Optional project description here.
                         */
                    }
                </div>

                {/*<Falcon7BButton />*/}

                {/*<MarkdownEditor />*/}
                {/*<TodoDiagramEntryPoint
                    todo={ null }
                    todoDiagram={ null }
                    onClose={ () => {} }
                />*/}

                <TodayNote note={ combinedProject?.todayNote || '' } />
                <ActiveTodos activeTodos={ combinedProject?.activeTodos || [] } />

                <div className="flex justify-end">
                    <HideProjectAndSectionTitlesCB />
                    <ProjectShowDescriptionsCB />
                </div>

                <TodayAIActions />

                { getYBlocks() }

                <TagFilters />

                <div className="mb-10">
                    <SectionTodos
                        combinedSection={ {
                            section: {
                                section_id: 0,
                                section_title: '',
                                section_order: 0,
                                section_project_id: INDEX_PROJECT_ID,
                            },
                            todos: [],
                            isOpened: true,
                        } }
                        project_id={ INDEX_PROJECT_ID }
                        titleVisible={ false }
                    />
                </div>

                {
                    combinedProject?.projects.map(project => {

                        return (
                            <ProjectView
                                key={`project-${ project.project_id }`}
                                project={ project}
                            />
                        )
                    })
                }

                {/*<TodayNoteDiagram noteDiagram={ combinedProject?.todayNoteDiagram || '' } />*/}

            </div>
        </>
    )
};

export default TodayView;